export const I18_ES = {
  LANGUAGE: 'ES',
  LNK_HEADER_ABOUT: 'YO',
  LNK_HEADER_SKILLS: 'Habilidades',
  LNK_HEADER_EXPERIENCE: 'Experiencia',
  LNK_HEADER_EDUCATION: 'Educación',
  LNK_HEADER_PROJECTS: 'Proyectos',
  LNK_HEADER_CONTACT: 'Contacto',
  LNK_HEADER_BLOG: 'Blog',

  TIT_PAGE_TITLE: 'Curriculum vitae',
  TIT_ABOUT: 'Acerca de mi',
  TIT_PROF_SKILLS: 'Habilidades técnicas',
  TIT_SOFT_SKILLS: 'Habilidades blandas',
  TIT_EXPERIENCE: 'Experiencia laboral',
  TIT_EDUCATION: 'Educación',
  TIT_PORTFOLIO: 'Portafolio',
  TIT_CONTACT: 'Contáctame',
  TIT_REFERENCES: 'Referencias',
  TIT_TECK_STACK: 'Perfil técnico',
  TIT_FOOTER: 'Quote',

  LBL_ALL: 'Todos',
  LBL_SEND_A_MESSAGE: 'Envíame un mensaje',
  LBL_NAME: 'Nombre',
  LBL_SUBJECT: 'Asunto',
  LBL_EMAIL: 'Correo',
  LBL_YOUR_MESSAGE: 'Tu mensaje',
  LBL_ADDRESS: 'Ubicación',
  LBL_PHONE: 'Teléfono',
  LBL_CV: 'Imprimir CV',
  LBL_LANGUAGES: 'Idiomas',

  BTN_LOAD_MORE: 'Cargar más',
  BTN_SEND: 'Enviar',
  BTN_BLOG_READ_MORE: 'Leer más',
  BTN_BLOG_BACK_TOBLOG: 'Regresar al blog',

  FILE_NAME: 'Resume Luis Arias ES'
};
